export default __webpack_public_path__ + "static/media/powerball_policy_v2.d9242c94.png";